import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ChartJSBarChart } from "../../../../Constant";
import { Bar } from "react-chartjs-2";
import { CHARTJS_BAR_CHART, CHARTJS_BAR_CHART_OPTION } from "../../../../Data/Charts/ChartJS";


const BarChart = () => {
  return (
    <Col xl="6" ms="12" className="box-col-6">
      <Card>
        <CommonCardHeader title={ChartJSBarChart} />
        <CardBody className="chart-block">
            <Bar id="myBarGraph" data={CHARTJS_BAR_CHART} options={CHARTJS_BAR_CHART_OPTION} width={778} height={400} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default BarChart;
